<template>
  <b-sidebar @shown="getStateFilterApi" sidebar-class="w-100 w-lg-25" id="jobs-filter" header-class="bg-aba-primary p-3" body-class="p-3" shadow backdrop>
    <template #header="{ hide }">
      <b-row align-v="center" class="flex-grow-1">
        <b-col class="d-flex">
          <span class="fs-5 fw-bolder text-white">
            <b-icon icon="sliders" class="mr-2"></b-icon>
            {{ translations[13590] }}
          </span>
        </b-col>
        <b-col cols="auto" class="d-flex ml-auto">
          <b-button class="bg-transparent border-0 p-1" @click="hide()">
            <b-icon icon="x" font-scale="1.5"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template #default="{ hide }">
      <h5 class="font-weight-light mb-3">{{ translations[13586] }}</h5>
      <b-tabs
        nav-class="mb-0 fs-6 d-flex w-100"
        no-nav-style>
        <b-tab active title-item-class="flex-fill h6" title-link-class="text-black px-0 py-1 fw-normal">
          <template #title>
            {{ translations[13422] }}
            <span v-b-tooltip.hover :title="translations[13601]" class="ml-2">
               <b-icon icon="info-circle" class="text-black-50" scale="0.8"></b-icon>
            </span>
          </template>
          <div class="mb-3">
            <select-profession v-model="selectProfession" :placeholder="translations[13602]" />
          </div>
        </b-tab>
        <b-tab title-item-class="flex-fill h6" title-link-class="text-black px-0 py-1 fw-normal">
          <template #title>
            {{ translations[13633] }}
            <span v-b-tooltip.hover :title="translations[13634]" class="ml-2">
               <b-icon icon="info-circle" class="text-black-50" scale="0.8"></b-icon>
            </span>
          </template>
          <div class="mb-3">
            <b-form-checkbox-group
              v-model="cluster"
              size="sm" switches
              stacked
              :options="clusters"
              value-field="id"
              text-field="name"/>
          </div>
        </b-tab>
      </b-tabs>
      <div class="mb-3">
        <filter-section-title :title-text="translations[13603]" :tooltip-text="translations[13604]" />
        <select-location v-model="selectLocation" :placeholder="translations[13605]" />
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[13606]" :tooltip-text="translations[13607]" />
        <b-form-select v-model="selectedState" size="sm">
          <b-form-select-option :value="0">{{translations[13237] }}</b-form-select-option>
          <b-form-select-option :value="item.id" v-for="item in federalStateItems" :key="item.id">
            {{ item.location_name}} ({{ item.jobs}})
          </b-form-select-option>
        </b-form-select>
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[609]" :tooltip-text="translations[13617]" />
        <b-form-input v-model="searchText" size="sm" :placeholder="translations[13724]" class="mb-2"></b-form-input>
        <b-form-select v-model="searchTextType" :options="searchTextTypeOptions" size="sm"></b-form-select>
      </div>
      <div class="mb-3">
        <filter-section-title :title-text="translations[13618]" :tooltip-text="translations[13619]" />
        <b-form-checkbox size="sm" v-model="checkboxFullTime" switch>
          {{ translations[13620]}}
        </b-form-checkbox>
        <b-form-checkbox size="sm" v-model="checkboxPartTime" switch>
          {{ translations[13621]}}
        </b-form-checkbox>
        <b-form-checkbox size="sm" v-model="checkboxMiniJob" switch>
          {{ translations[13622]}}
        </b-form-checkbox>
      </div>
      <div class="mb-4">
        <filter-section-title :title-text="translations[12150]" :tooltip-text="translations[13623]">
          <template v-if="!isAuth">
            <span v-b-tooltip.hover :title="translations[13624]" class="ml-2">
              <b-icon class="text-black-50" icon="shield-lock" />
            </span>
          </template>
        </filter-section-title>
        <b-form-checkbox :disabled="!isAuth" v-b-modal="!isAuth ? 'not-auth-modal' : ''" size="sm" v-model="checkboxSkillLevel2" switch>
          {{ translations[13625]}}
        </b-form-checkbox>
        <b-form-checkbox :disabled="!isAuth" v-b-modal="!isAuth ? 'not-auth-modal' : ''" size="sm" v-model="checkboxSkillLevel3" switch>
          {{ translations[13626]}}
        </b-form-checkbox>
      </div>
      <b-alert v-if="!isAuth" variant="secondary" show dismissible class="fs-6 mb-3">
        <p class="mb-2">
          {{ translations[13630] }}
        </p>
        <p class="mb-0">
          <a href="#"><b-icon icon="link45deg" class="mr-1"></b-icon>{{ translations[13631] }}</a>
        </p>
      </b-alert>
      <b-button @click="[hide(), search()]" variant="primary" size="sm" class="w-100">{{ translations[13632] }}</b-button>
    </template>
  </b-sidebar>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { Component, Vue } from 'vue-property-decorator';
import FilterSectionTitle from '@/components/FilterSidebar/FilterSectionTitle.vue';
import SelectProfession from '@/components/Widget/SelectProfession.vue';
import SelectLocation from '@/components/Widget/SelectLocation.vue';
import { ProfessionModule } from '@/store/modules/profession';
import { JobType } from '@/types/ProfessionType';
import { professionStateFilter } from '@/api/Profession';

interface IFederalState {id:string, jobs:number, location_name:string}

@Component({
  components: {
    SelectProfession,
    SelectLocation,
    FilterSectionTitle,
  },
})
export default class JobsFilter extends Vue {
  get federalStateItems(): IFederalState | null {
    return ProfessionModule.filterFederalStateItems;
  }

  get filterClusterId() {
    return ProfessionModule.jobFilter.cluster_id;
  }

  get translations() {
    return AppModule.translation;
  }

  get isAuth() {
    return UserModule.isUserAuth;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get clusters(): any[] {
    return AppModule.settingPortal.clusters;
  }

  // search professions
  get selectProfession() {
    return ProfessionModule.searchJobProfession;
  }

  set selectProfession(value: any) {
    ProfessionModule.SetSearchJobProfession(value);
    ProfessionModule.SetSearch({ obj: 'profession_id', value: value?.id || null });
  }
  // search professions

  // search locations
  get selectLocation() {
    return ProfessionModule.searchJobLocation;
  }

  set selectLocation(value: any) {
    ProfessionModule.SetSearchJobLocation(value);
    ProfessionModule.SetSearch({ obj: 'location_id', value: value?.id || null });
  }
  // search locations

  // full-text search
  get searchText() {
    return ProfessionModule.jobSearch.q;
  }

  set searchText(value) {
    ProfessionModule.SetSearch({ obj: 'q', value });
  }
  // full-text search

  // full-text search mode
  get searchTextType() {
    return ProfessionModule.jobSearch.qmode;
  }

  set searchTextType(value) {
    ProfessionModule.SetSearch({ obj: 'qmode', value });
  }

  get searchTextTypeOptions() {
    return [
      {
        value: 1,
        text: this.translations[10436],
      },
      {
        value: 2,
        text: this.translations[10437],
      },
    ];
  }
  // full-text search mode

  // search full-time jobs
  get checkboxFullTime() {
    return !ProfessionModule.jobFilter.fulltime;
  }

  set checkboxFullTime(value: any) {
    ProfessionModule.SetFilter({ obj: 'fulltime', value: Number(!value) });
  }
  // search full-time jobs

  // search part-time jobs
  get checkboxPartTime() {
    return !ProfessionModule.jobFilter.parttime;
  }

  set checkboxPartTime(value) {
    ProfessionModule.SetFilter({ obj: 'parttime', value: Number(!value) });
  }
  // search part-time jobs

  // search internships jobs
  get checkboxMiniJob() {
    return !ProfessionModule.jobFilter.minijob;
  }

  set checkboxMiniJob(value) {
    ProfessionModule.SetFilter({ obj: 'minijob', value: Number(!value) });
  }
  // search internships jobs

  // search skilled workers
  get checkboxSkillLevel2() {
    return !ProfessionModule.jobFilter.skill_level2;
  }

  set checkboxSkillLevel2(value) {
    ProfessionModule.SetFilter({ obj: 'skill_level2', value: Number(!value) });
  }
  // search skilled workers

  // search specialists / experts
  get checkboxSkillLevel3() {
    return !ProfessionModule.jobFilter.skill_level3;
  }

  set checkboxSkillLevel3(value) {
    ProfessionModule.SetFilter({ obj: 'skill_level3', value: Number(!value) });
  }
  // search specialists / experts

  // cluster = []
  get cluster() {
    const clusterStore = ProfessionModule.jobFilter.cluster_id;
    return clusterStore ? clusterStore.split(',') : [];
  }

  set cluster(value: any[]) {
    ProfessionModule.SetFilter({ obj: 'cluster_id', value: value.length ? String(value.join(',')) : 0 });
  }

  // search state
  get selectedState() {
    return ProfessionModule.jobFilter.state_id;
  }

  set selectedState(value) {
    ProfessionModule.SetFilter({ obj: 'state_id', value });
  }
  // search state

  get optionsLand() {
    return [
      { value: null, text: this.translations[13237] },
      { value: 0, text: `- ${this.translations[13608]} (123)` },
      { value: 1, text: `- ${this.translations[13609]} (123)` },
      { value: 2, text: `- ${this.translations[13610]} (123)` },
      { value: 3, text: `- ${this.translations[13611]} (123)` },
      { value: 4, text: `- ${this.translations[13612]} (123)` },
      { value: 5, text: `- ${this.translations[13613]} (123)` },
      { value: 5, text: `- ${this.translations[13614]} (123)` },
      { value: 5, text: `- ${this.translations[13615]} (123)` },
      { value: 5, text: `- ${this.translations[13616]} (123)` },
      { value: 5, text: `- ${this.translations[2013]} (123)` },
    ];
  }

  search() {
    // ProfessionModule.SET_PARAMS_DEFAULT();
    AppModule.SetVisibleJobs(false);
    AppModule.SetVisibleMap(false);
    this.$nextTick(() => {
      AppModule.SetVisibleJobs(true);
    });
  }

  getStateFilterApi() {
    if (!this.federalStateItems) {
      ProfessionModule.GetFederalStateItems({
        sid: this.languageSid,
      });
    }
  }
}
</script>
